/**
 * Search operator between terms in a search clause
 */
export type SearchOperator = "AND" | "OR";
